import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { apply as applyTheme } from './lib/theme'
import './theme.css'

// BEFORE render, not inside a component. A theme applied after the first paint
// is a white flash on a dark screen, at night, in a dark room.
applyTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
